import { cn } from "@/utils/utils";
import { FC } from "react";
import { FeedbackBadgeType, feedbackBadgeTypes } from "@/utils/feedbackBadges";

interface Props {
  badgeType: FeedbackBadgeType;
}

const FeedbackAccordionBadge: FC<Props> = ({ badgeType }) => {
  return (
    <div
      className={cn(
        "drop-shadow-none rounded-full text-[14px] flex justify-center items-center px-2 w-fit whitespace-nowrap text-center",
        feedbackBadgeTypes[badgeType]?.className||""
      )}
    >
      {feedbackBadgeTypes[badgeType]?.label||""}
    </div>
  );
};

export default FeedbackAccordionBadge;
